var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{directives:[{name:"popover",rawName:"v-popover",value:(`${_vm.content}`),expression:"`${content}`"}],staticClass:"ion-information-circled ml-1 info-icon c-help",attrs:{"data-placement":_vm.placement || 'top',"data-trigger":_vm.trigger || (_vm.is_mobile ? 'click' : 'hover')}})
}
var staticRenderFns = []

export { render, staticRenderFns }